import { ChangeDetectionStrategy, Component, Input, OnInit, SecurityContext } from '@angular/core';

import { Cause } from '@vi-iot/client';

import { AuthStore } from '@store';
import { environment } from '../../../../../../../environments/environment';

@Component({
  selector: 'app-how-to-repair',
  templateUrl: './how-to-repair.component.html',
  styleUrls: ['./how-to-repair.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HowToRepairComponent implements OnInit {
  @Input() causes: Cause[];
  @Input() boilerSerial: string;
  @Input() faultCode: string;

  readonly SecurityContext = SecurityContext;

  private readonly viessmannShop = environment.viessmannShop;
  viessmannShopUrl: string;

  constructor(public authStore: AuthStore) {}

  ngOnInit(): void {
    this.viessmannShopUrl = this.viessmannShop;
    if (this.boilerSerial) {
      const serialFirst7Digits = this.boilerSerial.substring(0, 7);
      this.viessmannShopUrl += this.faultCode
        ? `details/${serialFirst7Digits}?selectedDetailsTab=error_code_search&errorCode=${this.faultCode}`
        : `details/${serialFirst7Digits}?selectedDetailsTab=error_code_search`;
    }
  }
}
